import { useState } from "react";
import { faqList } from "@/mocks/melon";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <p className="mb-2 text-xs font-bold tracking-widest text-primary-500">FAQ</p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">关于瓜田日报的内容来源、更新节奏与使用方式，你可能想知道的都在这里。</p>
        </div>

        <div className="mt-8 space-y-3">
          {faqList.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-xs font-medium text-foreground-500">
                      {i + 1}
                    </span>
                    <span className="text-[15px] font-medium text-foreground-900">{f.q}</span>
                  </span>
                  <i
                    className={`ri-add-line text-lg text-foreground-400 transition-transform ${open ? "rotate-45 text-primary-500" : ""}`}
                    aria-hidden="true"
                  />
                </button>
                {open && <div className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{f.a}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}